import { render, staticRenderFns } from "./TranProgramProgramModuleList.vue?vue&type=template&id=5f14ab16&scoped=true"
import script from "./TranProgramProgramModuleList.vue?vue&type=script&lang=js"
export * from "./TranProgramProgramModuleList.vue?vue&type=script&lang=js"
import style0 from "./TranProgramProgramModuleList.vue?vue&type=style&index=0&id=5f14ab16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14ab16",
  null
  
)

export default component.exports